<template>
  <BaseContainer>
    <BaseContentContainer>
    <!-- Page Heading -->
    <h1 class="display-6 text-center text-success mb-4">Online Tutoring</h1>

    <!-- Intro Section -->
     <div class="fs-5 mb-4">
        We go beyond simply working through the prescribed syllabus or set content and support your goals with structured, engaging learning.
       We have in-depth knowledge of the curriculum, examinations, and marking schemes of the following exam boards and use this to effectivel support the students.

     </div>
  <div class="card border-success mb-4">
  <div class="card-header bg-success text-white fw-bold">
    Exam Boards Covered
  </div>
  <div class="card-body">
    <h5 class="card-title">UK & International Curricula</h5>
    <p class="card-text">
      We specialize in delivering Computer Science support tailored to the following boards:
    </p>

    <ul class="list-group list-group-flush">
      <li class="list-group-item">📘 OCR – GCSE & A-Level</li>
      <li class="list-group-item">📗 AQA – GCSE & A-Level</li>
      <li class="list-group-item">📙 Edexcel – GCSE & A-Level</li>
      <li class="list-group-item">📕 Cambridge – IGCSE & A-Level</li>
      <li class="list-group-item">🌐 IB – International Baccalaureate (MYP & IBDP)</li>
    </ul>
  </div>
</div>

    <!-- Highlighted Note -->
    <div class="alert alert-success text-center" role="alert" >
       <p class="fs-5">
      Our online tutoring uses the tutor's experience, observations and exposure to real-world contexts, disciplines and scenarios to help students connect academic concepts with how they are used in practice.
       </p>
    </div>
     <div class="fs-5 mb-4">
      Guiding students to develop and grow their understanding to rework in different topics of Computer Science (AQA, OCR, Cambridge, Edexcel ) which includes theoretical and abstract concepts, computational & critical thinking, problem solving, algorithms/pseudocode, data structures & programming (with Python, Java, C#, JS) along with other related topics. For A-levels CS projects understanding and applying the OOP + functional approach to design and development to build efficient programs.
       
     </div>
        <div class="alert alert-success text-center" role="alert">
       <p class="fs-5">
      The online environment also provides access to resources, networks, visualisations, simulations, software, virtual environments and distributed systems that can transform the learning experience.
        </p>
    </div>
     <div class="alert alert-success text-center" role="alert">
       <p class="fs-5">
      Concepts that may appear abstract in a textbook can be explored, observed and demonstrated in practical contexts.
      We ensure you're prepared — whether for exams or your own tech-driven ambitions.
        </p>
    </div>
      
      
   

    <!-- CTA -->
    <div class="text-center mt-5">
      <p class="fs-5">
        Whether you're preparing forgives you the edge you need.
      </p>
      <button class="btn btn-outline-success">Explore AI Courses</button>
    </div>
    </BaseContentContainer>
  </BaseContainer>
</template>

<script>
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
export default {
  name: 'AIOverview',
   components: {
      BaseContainer,BaseContentContainer,
  },
  data() {
    return {
      activeIndex: 0,
      sections: [
        {
          title: 'Core AI Concepts',
          items: [
            'Artificial Intelligence: Introduction and Definitions',
            'Machine Learning & Expert Systems',
            'Deep Learning and Neural Networks',
            'Comparison of ML vs DL',
            'Chatbots and Automated Systems'
          ]
        },
        {
          title: 'AI Algorithms & Applications',
          items: [
            'Shortest Path Algorithms (Dijkstra & A*)',
            'Game AI Applications (Maze solvers, Board Game AI)',
            'Web Crawlers and Data Extraction',
            'Use of AI in Search and Recommendation'
          ]
        },
        {
          title: 'Machine Learning Models',
          items: [
            'Supervised, Unsupervised & Reinforcement Learning',
            'Semi-supervised (Active) Learning',
            'Labelled vs Unlabelled Data',
            'Regression & Classification Models',
            'Backpropagation in Neural Networks'
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.custom-accordion-header {
  background-color: #198754 !important; /* Bootstrap green */
  color: white !important;
  font-weight: 500;
}
.accordion-body ul {
  padding-left: 1.2rem;
}
</style>

